// Each suffix represents another group of three digits. Exceptionally large or
// non-finite estimates use a compact fallback instead of four leading digits.
const GUESS_SUFFIXES = [
  '',
  'thousand',
  'million',
  'billion',
  'trillion',
  'quadrillion',
  'quintillion',
  'sextillion',
  'septillion',
  'octillion',
  'nonillion',
  'decillion',
  'undecillion',
  'duodecillion',
  'tredecillion',
  'quattuordecillion',
  'quindecillion',
  'sexdecillion',
  'septendecillion',
  'octodecillion',
  'novemdecillion',
  'vigintillion',
] as const

export function formatGuessCount(value: number): string {
  if (!Number.isFinite(value)) return 'over 999 vigintillion'

  const normalized = Math.max(0, Math.round(value))
  if (normalized < 1000) return String(normalized)

  let group = Math.floor(Math.log10(normalized) / 3)
  let leading = Math.round(normalized / (1000 ** group))
  if (leading >= 1000) {
    leading = 1
    group += 1
  }

  if (group < GUESS_SUFFIXES.length) return `${leading} ${GUESS_SUFFIXES[group]}`

  return `${leading} × 10 to the ${group * 3}th power`
}
